import React from 'react';
import ConnectedLocationSearch, {
  LocationSearchContainer as LocationSearchComponent,
} from '../../../../containers/LocationSearchContainer';

class LocationSearch extends React.Component {
  validateProps({ caption, trackingPage, searchType }) {
    return (
      typeof caption === 'string' &&
      typeof trackingPage === 'string' &&
      typeof searchType === 'string'
    );
  }

  componentDidMount() {
    const { caption, trackingPage, searchType } = this.props;

    if (!this.validateProps({ caption, trackingPage, searchType })) {
      throw new Error('Incorrect prop-types for Storyblok LocationSearchContainer component');
    }
  }

  render() {
    const { caption, trackingPage, searchFilter, brand, brandName, searchType } = this.props;

    return (
      <ConnectedLocationSearch
        caption={caption}
        trackingPage={trackingPage}
        searchFilter={searchFilter}
        brand={brand}
        brandName={brandName}
        searchType={searchType}
      />
    );
  }
}

LocationSearch.propTypes = {
  caption: LocationSearchComponent.propTypes.caption,
  trackingPage: LocationSearchComponent.propTypes.trackingPage,
  searchFilter: LocationSearchComponent.propTypes.searchFilter,
  brand: LocationSearchComponent.propTypes.brand,
  brandName: LocationSearchComponent.propTypes.brandName,
  searchType: LocationSearchComponent.propTypes.searchType,
};

LocationSearch.defaultProps = {
  caption: LocationSearchComponent.defaultProps.caption,
  trackingPage: LocationSearchComponent.defaultProps.trackingPage,
  searchFilter: LocationSearchComponent.defaultProps.searchFilter,
  brand: LocationSearchComponent.defaultProps.brand,
  brandName: LocationSearchComponent.defaultProps.brandName,
  searchType: LocationSearchComponent.defaultProps.searchType,
};

export default LocationSearch;
